import PropTypes from "prop-types";
import React from "react";
const DisplayContact = ({contact}) => (
  <div>
    <div className="verified-address-message color-coral-2-bg">
        Please make sure your verified address is correct.
    </div>
    <div>
      {contact.first_name}
      {" "}
      {contact.last_name}
    </div>
    <div>
      {contact.street_address_1}
      {" "}
      {contact.street_address_2}
    </div>
    <div>
      {contact.city}
      ,
      {" "}
      {contact.state}
      {" "}
      {contact.zip}
    </div>
    <div>
      {contact.email}
    </div>
    <div>
      {contact.phone || "no valid phone number given"}
    </div>
  </div>
);

export default DisplayContact;

DisplayContact.propTypes = {"contact": PropTypes.object.isRequired};
